import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';

import './styles.css'
import { Button, Input } from '../../components';
import { saveDeck, deckBuilderStrings } from '../../utils';
import { getUserDeckById } from '../../services';

const Deckbuilder = () => {
    const [searchParams] = useSearchParams();
    const [decklist, setDecklist] = useState('');
    const [maybeboard, setMaybeboard] = useState('');
    const [title, setTitle] = useState<string>('')
    const [version, setVersion] = useState<string>(deckBuilderStrings.initialVersion)
    const [description, setDescription] = useState<string>('')
    const [pageTitle, setPageTitle] = useState(deckBuilderStrings.defaultPageTitle)
    const [id, setId] = useState<string>('')

    const navigate = useNavigate()

    useEffect(() => {
        const id = searchParams.get("deckId")

        if (!id) {
            resetData()
            return
        }
        
        setId(id)
        getUserDeckById(id).then(deck => {
            if (!deck) return

            setVersion(deck.version)
            setTitle(deck.title)
            setDescription(deck.description)
            setDecklist(deck.decklist)
            setMaybeboard(deck.maybeboard)
        });
    }, [searchParams])

    const resetData = () => {
        setVersion(deckBuilderStrings.initialVersion)
        setTitle('')
        setDescription('')
        setDecklist('')
        setMaybeboard('')
        setPageTitle(deckBuilderStrings.defaultPageTitle)
    }

    const confirmDecklist = () => {
        if (!decklist) return
        try {
            saveDeck({
                title: title?.trim(),
                version: version?.trim(),
                description: description?.trim(),
                decklist: decklist?.trim(),
                maybeboard: maybeboard?.trim(),
                id: id
            })
            navigate('/mydecks')
        } catch (error) {
            toast.error("Rolou algum erro", { theme: 'colored'});
            console.log(error)
        }
    }

    return (
        <div className='deckbuilder-wrapper'>
            <h1>{pageTitle}</h1>
            <div className='input-version-wrapper'>
                <p>{deckBuilderStrings.version}</p>
                <Input
                    type='text'
                    value={version}
                    id='deck-version'
                    onChange={(e) => setVersion(e.target.value)}
                />
            </div>
            <div className='input-label-value-wrapper'>
                <p>{deckBuilderStrings.name}</p>
                <Input
                    type='text'
                    autoFocus
                    value={title}
                    id='deck-title'
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>
            <div className='input-label-value-wrapper'>
                <p>{deckBuilderStrings.description}</p>
                <textarea
                    className='description-text-area'
                    value={description}
                    id='deck-description'
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>
            <div className='input-label-value-wrapper'>
                <p>{deckBuilderStrings.decklist}</p>
                <textarea
                    value={decklist}
                    id='decklist'
                    onChange={(e) => setDecklist(e.target.value)}
                />
            </div>
            <div className='input-label-value-wrapper'>
                <p>{deckBuilderStrings.maybeboard}</p>
                <textarea
                    value={maybeboard}
                    id='maybeboard'
                    onChange={(e) => setMaybeboard(e.target.value)}
                />
            </div>
            <Button onClick={confirmDecklist}>{deckBuilderStrings.saveDeckButton}</Button>
            <ToastContainer />
        </div>
    )
}

export default Deckbuilder
